import React from "react";
import { compose } from "src/helpers";
import {
    withHookForAggregateBook,
    withHookForBooks,
} from "src/modules/book/operations";
import { withStateAndActionsForBook } from "src/modules/book/resolvers";
import ListView from "./component";

const List: React.FC = (props: any) => {
    return <ListView {...props} />;
};

export default compose(
    withStateAndActionsForBook,
    withHookForBooks,
    withHookForAggregateBook,
)(List);
